<div class="partner-store-inventory-body">
    <!--Body Header-->
    <partner-mart-locations-header [store]="store"></partner-mart-locations-header>

    <!-- Inventory grid -->
    <partner-mart-locations-inventory-grid [storeId]="storeId" [store]="store" [merchantId]="merchantId"></partner-mart-locations-inventory-grid>
</div>
